<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection>
            <template #title>
                Attendance Information
            </template>

            <FormGroup
                name="user_id"
                label="Student">
                <Select
                    v-model="form.user_id"
                    name="user_id"
                    :options="students"
                    placeholder="Please select a student..."/>
            </FormGroup>

            <FormGroup
                name="status"
                label="Status">
                <Select
                    v-model="form.status"
                    name="status"
                    :options="statuses"
                    :clearable="false"
                    placeholder="Please select a status..."/>
            </FormGroup>

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Select from "@/Components/Form/Select.vue";
import axios from "axios";
import {optionsToArray} from "@/Lib/Helpers";
import {CourseApplicationStatus as ApplicationStatus} from "@/Lib/Enums";

export default {

    name: "CourseApplicationForm",

    data() {
        return {
            students: [],
            statuses: [
                {label: "Pending", value: ApplicationStatus.Pending},
                {label: "Accepted", value: ApplicationStatus.Accepted},
                {label: "Rejected", value: ApplicationStatus.Rejected},
            ],
        };
    },

    async created() {
        this.students = optionsToArray((await axios.get(route('api.users.index') + '?list&role=student')).data);
    },

    emits: ['submit'],

    inject: ['form'],

    components: {
        FormSection,
        FormGroup,
        Select,
        Textarea,
        InputError,
    },
};

</script>
